import { render } from "./LayerSwitcherComponent.vue?vue&type=template&id=3b29196d"
import script from "./LayerSwitcherComponent.vue?vue&type=script&lang=js"
export * from "./LayerSwitcherComponent.vue?vue&type=script&lang=js"

import "./LayerSwitcherComponent.vue?vue&type=style&index=0&id=3b29196d&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__